import axios from 'axios'
import {API_URL} from '../constants';

const TALK_API_URL = `${API_URL}/talk`;

class TalkService {

    initializeSearchInfo(fromDate, status, createdBy, msgTo, workOrderId, parentId){
        var info = {
            fromDate: fromDate,
            status: status,
            createdBy: createdBy,
            msgTo: msgTo,
            workOrderId: workOrderId,
            parentId: parentId
        };
        console.log("Talk Search info", info)
        return info;        
    }

    retrieveTalkBy(fromDate, status, createdBy, msgTo, workOrderId, parentId) {
        let info = this.initializeSearchInfo(fromDate, status, createdBy, msgTo, workOrderId, parentId);
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/findBy`,info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveTalkSendToCurrentUser(fromDate) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/findByReceiver`, {fromDate: fromDate}, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveTalkCreatedByCurrentUser(fromDate) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/findByCreator`, {fromDate: fromDate}, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countByStatus(status) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/countByStatus`, {status: status}, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }        

    save(talk) {
        let info = {
            msg: talk.msg,
            msgTo: talk.msgTo,
            msgFrom: undefined,
            workOrderId: talk.workOrderId,
            parentId: talk.parentId,
            createdBy: undefined,
            status: talk.status
        }
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/save`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateStatus(talk, status) {
        let info = {
            id: talk.id,
            status: status
        }
        const token = sessionStorage.getItem('token');
        return axios.post(`${TALK_API_URL}/updateStatus`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new TalkService()